const organization = {
    require_membership: 'Пользователь должен быть участником организации, чтобы продолжить.',
};
export default Object.freeze(organization);
